import { deleteAllCookies, isLoggedIn } from "../utils/helperFunctions";
import { kioskApi } from "./apiGodFile";
import apiList from "./apiList";

export const callApi = {
  get: async (url, data, headers, counter = 0) => {
    try {
      const response = await kioskApi({
        method: "GET",
        url: `${url}`,
        params: data,
        headers: {
          ...headers,
        },
      });

      return response.data;
    } catch (error) {
      let apiResponse = await handleResponse(
        error.response,
        callApi.get,
        url,
        data,
        headers,
        counter
      );

      return apiResponse;
    }
  },
  post: async (url, data, headers, counter = 0) => {
    try {
      const response = await kioskApi({
        method: "POST",
        url: `${url}`,
        data,
        headers: {
          ...headers,
        },
      });

      return response.data;
    } catch (error) {
      let apiResponse = await handleResponse(
        error.response,
        callApi.post,
        url,
        data,
        headers,
        counter
      );

      return apiResponse;
    }
  },
  patch: async (url, data, headers, counter = 0) => {
    try {
      const response = await kioskApi({
        method: "PATCH",
        url: `${url}`,
        data,
        headers: {
          ...headers,
        },
      });

      return response.data;
    } catch (error) {
      let apiResponse = await handleResponse(
        error.response,
        callApi.patch,
        url,
        data,
        headers,
        counter
      );

      return apiResponse;
    }
  },
  put: async (url, data, headers, counter = 0) => {
    try {
      const response = await kioskApi({
        method: "PUT",
        url: `${url}`,
        data,
        headers: {
          ...headers,
        },
      });

      return response.data;
    } catch (error) {
      let apiResponse = await handleResponse(
        error.response,
        callApi.put,
        url,
        data,
        headers,
        counter
      );

      return apiResponse;
    }
  },
  delete: async (url, data, headers, counter = 0) => {
    try {
      const response = await kioskApi({
        method: "DELETE",
        url: `${url}`,
        data,
        headers: {
          ...headers,
        },
      });

      return response.data;
    } catch (error) {
      let apiResponse = await handleResponse(
        error.response,
        callApi.delete,
        url,
        data,
        headers,
        counter
      );

      return apiResponse;
    }
  },
};

export const handleResponse = async (
  response,
  callback,
  url,
  data,
  headers,
  counter = 0
) => {
  if (counter > 1) {
    window.location.href = `${window.location.origin}/signup`;
    return;
  }
  if (response.data.status === 498 || response.data.status === 401) {
    let refreshResponse = await handleToken();
    if (refreshResponse) {
      const callbackResponse = await callback(url, data, headers, counter + 1);
      if (callbackResponse) {
        return callbackResponse;
      }
    }
  } else {
    return response.data;
  }
};

export const handleToken = async () => {
  //referCookieDirectly

  if (isLoggedIn()) {
    const success = await callTokenApi.refresh();
    if (success) {
      return success;
    } else {
      //insertAlertHere
      //youhavebeenloggedout
      //referCookieDirectly

      deleteAllCookies();
      const guestSuccess = await callTokenApi.guest();
      if (guestSuccess) {
        return guestSuccess;
      } else {
        //insertAlertHere
        //guestApiFail
      }
    }
  } else {
    const success = await callTokenApi.guest();
    if (success) {
      return success;
    } else {
      //insertAlertHere
      //guestApiFail
    }
  }
  return true;
};

export const callTokenApi = {
  guest: async () => {
    try {
      const response = await kioskApi({
        method: "GET",
        url: apiList.login.guest,
      });

      const { data } = response;
      return data.status === 200;
    } catch (error) {
      return false;
    }
  },
  refresh: async () => {
    try {
      const response = await kioskApi({
        method: "PUT",
        url: apiList.login.refresh,
      });
      const { data } = response;
      return data.status === 200;
    } catch (error) {
      return false;
    }
  },
};
